import {SLIDER, MEDIA} from "../../constants";

const setHeaderAnchorsCurrentClass = () => {
	if (!document.querySelector(`#state-switch`).checked)
	{
		SLIDER.SLIDES.forEach((slide, i) => {
			const halfDisplay = window.innerHeight / 2;
			const topBound = window.innerWidth >= MEDIA.DESKTOP ? slide.offsetTop : slide.offsetTop - halfDisplay;
			const bottomBound = window.innerWidth >= MEDIA.DESKTOP ? slide.offsetTop + slide.offsetHeight : slide.offsetHeight + slide.offsetTop - halfDisplay;

			if (window.innerWidth >= MEDIA.DESKTOP)
			{
				const prevCurrentAnchor = SLIDER.HEADER_ANCHORS.find((anchor) => anchor.classList.contains(`current`));
				prevCurrentAnchor ? prevCurrentAnchor.classList.remove(`current`) : false;
				const nextCurrentAnchor = SLIDER.HEADER_ANCHORS.find((anchor) => anchor.hash === location.hash);
				nextCurrentAnchor ? nextCurrentAnchor.classList.add(`current`) : SLIDER.HEADER_ANCHORS[0].classList.add(`current`);
				return;
			}

			topBound <= window.pageYOffset && bottomBound > window.pageYOffset ? SLIDER.HEADER_ANCHORS[i].classList.add(`current`) : SLIDER.HEADER_ANCHORS[i].classList.remove(`current`);
		});
	}
};

const setHeaderFixedClass = () => {
	const header = document.querySelector(`header`);
	window.pageYOffset > 0 ? header.classList.add(`fixed`) : header.classList.remove(`fixed`);
};

export const initWindow = () => {
	setHeaderAnchorsCurrentClass();
	setHeaderFixedClass();
};
